import { render, staticRenderFns } from "./CustomerPrices.vue?vue&type=template&id=f57f9638&"
import script from "./CustomerPrices.vue?vue&type=script&lang=js&"
export * from "./CustomerPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports